import React, { useState, useEffect } from 'react';
import ThemeModeContext from './ThemeModeContext';

var ThemeModeProvider = function ThemeModeProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(typeof window !== 'undefined' ? localStorage.getItem('theme') || 'lightMode' : 'lightMode'),
      localStorageThemeMode = _useState[0],
      setLocalStorageThemeMode = _useState[1];

  useEffect(function () {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      setLocalStorageThemeMode('darkMode');
    }

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function (e) {
      setLocalStorageThemeMode(e.matches ? 'darkMode' : 'lightMode');
    });
  }, []);
  useEffect(function () {
    localStorage.setItem('theme', localStorageThemeMode);
  }, [localStorageThemeMode]);

  var toggleThemeMode = function toggleThemeMode() {
    setLocalStorageThemeMode(function (prevState) {
      return prevState === 'lightMode' ? 'darkMode' : 'lightMode';
    });
  };

  var value = {
    themeMode: localStorageThemeMode,
    toggleThemeMode: toggleThemeMode
  };
  return /*#__PURE__*/React.createElement(ThemeModeContext.Provider, {
    value: value
  }, children);
};

ThemeModeProvider.defaultProps = {
  children: undefined
};
export default ThemeModeProvider;